import React from 'react';
import {Row} from 'reactstrap'; //Card, CardTitle, CardText, CardBody, Col
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Frameworks from './Frameworks'
import { signout } from '../../redux/actions/userActions';

class Content extends React.Component {

  render() {
    return (
      <div className="content-container">
        <Row>
          {
            this.props.enabledFrameworks ? 
            <Frameworks
              categories={this.props.enabledFrameworks}
              headingDescription="Choose a framework to edit its controls' help texts." 
            />
            :
            null
          }
          
          
        </Row>
      </div>
    )
  }

}

function mapStateToProps (state) {
  return {
      user: state.auth.user,
      enabledFrameworks: state.controlsData.enabledFrameworks,
      dataLoaded: !state.controlsData.loading,
      sidebar: state.sidebar
  }
}

export default connect(mapStateToProps, { signout })(withRouter(Content));



// WEBPACK FOOTER //
// ./src/components/content_management/Content.js